export const getPaymentMethodAbrv = (paymentMethodAbrv: string) => {
	if (paymentMethodAbrv) {
		const lowercasedPaymentMethod = paymentMethodAbrv.toLowerCase();

		return lowercasedPaymentMethod.includes("aircash")
			? "aircash"
			: lowercasedPaymentMethod;
	}
};
